import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2ClockOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M30.84 16c0 7.382-5.747 13.433-13 13.95v-2c6.15-.512 11-5.67 11-11.95 0-6.617-5.383-12-12-12s-12 5.383-12 12c0 6.238 4.786 11.375 10.879 11.943l-1.285 1.835C7.859 28.632 2.84 22.898 2.84 16c0-7.72 6.28-14 14-14s14 6.28 14 14m-13 .268V8h-2v7.732L11.643 23h2.31z" /></svg>
);
